<template>
  <Breadcrumbs
      title="View Trust Details"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Trust Management', path: '/view-trust-details' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <viewTrustDetailsTable/>
    </div>
  </div>
</template>

<script>

import viewTrustDetailsTable from "@/pages/master_data/trust_management/viewTrustDetailsTable.vue";

export default {
  components: {
    viewTrustDetailsTable
  }
}

</script>